import {
    Html,
    Head,
    Preview,
    Body,
    Container,
    Section,
    Heading,
    Text,
    Hr,
} from '@react-email/components';
import { render } from '@react-email/render';
import FormValues from './FormValues';
import {ReactElement} from "react";
import {AppData} from "./fetchAppData";

export default async (data: FormValues, appData: AppData) : Promise<string> => {

    let mail = (<Html lang="de">
        <Head />
        <Body>
            <Container>
                <Heading>Neues Service-Ticket</Heading>
                <Section>
                    <Text><strong>Land:</strong> {data.land}</Text>
                    <Text><strong>Filialnummer:</strong> {data.filialnummer}</Text>
                    <Text><strong>Filialname:</strong> {data.filialname}</Text>
                    <Text><strong>Seriennummer:</strong> {data.serialNumber}</Text>
                    <Text><strong>Gewerk:</strong> {data.trade}</Text>
                    <Text><strong>Kategorie:</strong> {appData.produktKategorie.find(k => k.id.toString() === data.category)?.name} </Text>
                    <Text><strong>Hersteller:</strong> {appData.hersteller.find(h => h.id.toString() === data.producer)?.name}</Text>
                    <Text><strong>Errichterpaket vorhanden:</strong> {data.erichterpaket === "yes" ? "Ja" : "Nein"}</Text>
                    <Text><strong>Seriennummer Errichterpaket:</strong> {data.erichterpaket === "yes" ? data.serialNumberErrichterPaket : "-"}</Text>
                </Section>

                <Hr />

                <Section>
                    <Heading>Fehlerangaben</Heading>
                    <Text><strong>Fehler:</strong> {data.reason}</Text>
                    <Text><strong>Fehlerbeschreibung:</strong> {data.defectDescription}</Text>
                </Section>

                <Hr />

                <Section>
                    <Heading>Lieferadresse</Heading>
                    <Text><strong>Anschrift:</strong> {data.deliveryAddress.companyName}, {data.deliveryAddress.streetNumber}, {data.deliveryAddress.postalCode} {data.deliveryAddress.city}</Text>
                    <Text><strong>Ansprechpartner:</strong> {data.deliveryAddress.contactPerson}</Text>
                    <Text><strong>Telefon:</strong> {data.deliveryAddress.phone}</Text>
                    <Text><strong>E-Mail:</strong> {data.deliveryAddress.email}</Text>
                </Section>

                {(data.deliveryAndPickUpAdressSame === "no" && data.pickupAddress) && (
                    <>
                        <Hr />
                        <Section>
                            <Heading>Abholadresse</Heading>
                            <Text><strong>Anschrift:</strong> {data.pickupAddress.companyName}, {data.deliveryAddress.streetNumber}, {data.deliveryAddress.postalCode} {data.deliveryAddress.city}</Text>
                            <Text><strong>Ansprechpartner:</strong> {data.pickupAddress.contactPerson}</Text>
                            <Text><strong>Telefon:</strong> {data.pickupAddress.phone}</Text>
                            <Text><strong>E-Mail:</strong> {data.pickupAddress.email}</Text>
                        </Section>
                    </>
                )}

                <Hr />
            </Container>
        </Body>
    </Html>)

    return await render(mail as ReactElement)
}